import React from 'react'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'

import Header from 'app/BCKSPage/components/Header'
import AndroidHandler from 'utils/androidHandler'
import { PDFViewer } from 'components/PDFViewer'
import { useBCKSDesktopView } from 'app/BCKSPage/hooks/useBCKSDesktopView'
import { BCKSDesktopPageShell } from 'app/BCKSPage/components/BCKSDesktopPageShell'

const PATH_BACK = '/bcks/invitation/final'

const BCKSPDFPreview = ({ url, title }) => {
  const androidHandler = AndroidHandler()
  const router = useRouter()

  const { isDesktop } = useBCKSDesktopView()

  const handleBackClick = () => {
    if (androidHandler.enabled)
      historyUtils.backToApp(() => router.replace(PATH_BACK))
    else router.replace(PATH_BACK)
  }

  if (isDesktop) {
    return (
      <BCKSDesktopPageShell
        title={title}
        pageLabel={title || 'Dokumen'}
        rawContent
      >
        <div className="max-w-6xl mx-auto py-4">
          <PDFViewer url={url} />
        </div>
      </BCKSDesktopPageShell>
    )
  }

  return (
    <div className="min-h-screen max-w-xl mx-auto bg-surface-subdued">
      <Header title={title} onBackClick={handleBackClick} />
      <PDFViewer url={url} />
    </div>
  )
}

export default BCKSPDFPreview
